export default function BylawText({ text }) {
  return (
    <div className="w-full leading-[1.3rem] indent-8 sm:indent-20 max-w-[800px] text-left">
      {text}
    </div>
  );
}
